import * as constants from "../constants/constants";
const initialState = {
    isLoading: false,
    data: null,
    error: null,
};

export const getTonnageReducer = (state = initialState, action) => {
    switch (action.type) {
        case constants.GET_TONNAGE_START:
            return { ...state, isLoading: true, error: null, data: null };
        case constants.GET_TONNAGE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                error: null,
                data: action.payload,
            };
        case constants.GET_TONNAGE_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
                data: null,
            };
        default:
            return { ...state };
    }
};
